export const globalSearchActions = {
    close: 'globalSearch/close',
    reset: 'globalSearch/reset',
};
